import React, { useState, useEffect, useCallback, useRef } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid, Card, CardContent  
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import {APIProvider, Map , useMap , useMapsLibrary , AdvancedMarker , Pin} from '@vis.gl/react-google-maps';
import ChatApp from "./Bell_icon";
//Services
import PassengerApi from "Services/Passenger";
import { API_ENDPOINTS , CUSTOM_CONSTANTS } from "../../../../Constants";
dayjs.extend(customParseFormat);
dayjs.extend(utc);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PassengerUpdate = (props) => {
  const { openDialog, id, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [details, setdetails] = useState([]);
  const [chatdetails, setchatdetails] = useState([]);

  const getDetails = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
     // console.log("fetched chat--->",res?.data?.data?.data[0]?.userRideRequestData?.chatDetails)
      if (res?.data?.status === true) {
        setdetails(res?.data?.data?.data);
        if(res?.data?.data?.data[0]?.userRideRequestData?.chatDetails?.length > 0)
        {  
        //   console.log("set");
          setchatdetails(res?.data?.data?.data[0]?.userRideRequestData?.chatDetails);
        }else{
          setchatdetails([]);
        }
      } else {
        setdetails([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("Get member / partner details Api", err);
    };
    //console.log("member id--->",id);
    PassengerApi.getPassengertriphistorybyid(id).then(onSuccess, onFailure);
  }, [id]);

  useEffect(() => {
    openDialog && getDetails();
  }, [openDialog]);

  const dataRows = _.map(details || [], (data, index) => ({
    bookingId:data?.userRideRequestData.bookingId,
    username: data?.userRideRequestData.user_name,
    drivername:data?.driverName && Object.keys(data.driverName).length > 0? data?.driverName.firstName+" "+data?.driverName.lastName : "Driver not yet assigned!",
    distance:(data?.userRideRequestData?.tripDistance ?? 0).toFixed(2)+" "+data?.userRideRequestData.tripDistanceUnit,
    tripduration:(data?.userRideRequestData?.tripMinutes ?? 0).toFixed(2)+" "+"Mins",
    ridestarttime:data?.userRideRequestData.startedAt?dayjs.utc(data?.userRideRequestData.startedAt).format("D of MMMM YYYY hh:mm:ss A"):"Not Started",
    rideendtime:data?.userRideRequestData.completedAt?dayjs.utc(data?.userRideRequestData.completedAt).format("D of MMMM YYYY hh:mm:ss A"):"Not Started",
    booking_time:data?.userRideRequestData.tripBookedAt?dayjs.utc(data?.userRideRequestData.tripBookedAt).format("D of MMMM YYYY hh:mm:ss A"):"Not Booked",
    pickupaddress:data?.userRideRequestData.pickupAddress,
    stop1_address:data?.userRideRequestData.stop1_address,
    stop2_address:data?.userRideRequestData.stop2_address,
    stop3_address:data?.userRideRequestData.stop3_address,    
    dropaddress:data?.userRideRequestData.dropAddress,
    onboardingwaitingtime:(data?.userRideRequestData?.freeStopsWaitingMinutes ?? 0).toFixed(2),
    tripwaitingtime:data?.userRideRequestData?.freeTripWaitingMinutes,
    onboardingwaitingfare:(data?.userRideRequestData?.tripStopWaitingPrice ?? 0).toFixed(2),
    tripwaitingfare:(data?.userRideRequestData?.tripWaitingPrice ?? 0).toFixed(2),
    amount:data?.userRideRequestData.isPaid ? 
           (data?.userRideRequestData?.estimatedFare ?? 0).toFixed(2)+" "+CUSTOM_CONSTANTS.BASE_CURRENCY:"N/A",
    baseprice:(data?.userRideRequestData?.base_fare ?? 0).toFixed(2)+" "+CUSTOM_CONSTANTS.BASE_CURRENCY,


	 bookingfee:(data?.userRideRequestData?.booking_fare ?? 0).toFixed(2)+" "+CUSTOM_CONSTANTS.BASE_CURRENCY,
	addtofare:(data?.userRideRequestData?.proposed_fare_amt ?? 0).toFixed(2)+" "+CUSTOM_CONSTANTS.BASE_CURRENCY,
         fareincrease:(data?.userRideRequestData?.increasedFare ?? 0).toFixed(2)+" "+CUSTOM_CONSTANTS.BASE_CURRENCY,
         faredecrease:(data?.userRideRequestData?.decreasedFare ?? 0).toFixed(2)+" "+CUSTOM_CONSTANTS.BASE_CURRENCY,
	
	  cancelReason: data?.userRideRequestData.cancelReason || "N/A",
     cancelledBy: data?.userRideRequestData.cancelledBy || "N/A",

    distancefare:(data?.userRideRequestData?.distancefare ?? 0).toFixed(2)+" "+CUSTOM_CONSTANTS.BASE_CURRENCY,
    minutefare:(data?.userRideRequestData?.timefare ?? 0).toFixed(2)+" "+CUSTOM_CONSTANTS.BASE_CURRENCY,
    status:data?.userRideRequestData.tripStatus,
    pickuplat:Number(data?.userRideRequestData.pickupLocation.latitude),    
    pickuplong:Number(data?.userRideRequestData.pickupLocation.longitude),
    dropLat:Number(data?.userRideRequestData.dropLocation.latitude),
    droplong:Number(data?.userRideRequestData.dropLocation.longitude),
    user_notes:data?.userRideRequestData?.userNotes,
    row: data,
  }));

  const libraries = ["places", "drawing" , 'routes'];

  function Directions({ dataRows })
{
  const map= useMap();
  const routesLibrary= useMapsLibrary("routes"); 
  const [renderers, setRenderers] = useState([]);

useEffect(()=>{
if(!routesLibrary || !map ) return;

const newRenderers = [];
dataRows.forEach((row) => {
  const directionsService = new routesLibrary.DirectionsService();
  const directionsRenderer = new routesLibrary.DirectionsRenderer({ map });

  directionsService
    .route({
      origin: { lat: row.pickuplat, lng: row.pickuplong },
      destination: { lat: row.dropLat, lng: row.droplong },
      travelMode: "DRIVING",
    })
    .then((response) => {
      directionsRenderer.setDirections(response);
      //console.log("Direction route added", response);
    });

  newRenderers.push(directionsRenderer);
});

// Set new renderers and clean up old ones
setRenderers((prevRenderers) => {
  prevRenderers.forEach((renderer) => renderer.setMap(null)); // Clear previous routes
  return newRenderers;
});

return () => {
  // Cleanup when component unmounts
  newRenderers.forEach((renderer) => renderer.setMap(null));
};
}, [dataRows, routesLibrary, map]);

  return null;
}   

  return (
    <>
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth={"xl"}
        aria-describedby="dialog-box"
        className={classes.root}
      >
        <DialogTitle>
          <section className={classes.dialogTitleContainer}>
            <Typography variant="body1" className={classes.title}>
              Trip Details
            </Typography>
            <IconButton aria-label="close" onClick={handleClose}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </section>
        </DialogTitle>
        <DialogContent>

{/*trip details*/}

<Card sx={{ p: 2, borderRadius: "12px", boxShadow: 3 }}>
      {dataRows.length > 0 ? (
        dataRows.map((row, index) => (
          <CardContent key={index}>
            <Grid container spacing={2}>
              {/* Left Section */}
              <Grid item xs={12} md={6}>
                <Card sx={{ p: 2, borderRadius: "12px", backgroundColor: "#f9f9f9" }}>
                  <CardContent>
                    <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
                      Ride Details
                    </Typography>
                    {[
                      { label: "Passenger Name", value: row.username },
                      { label: "Driver Name", value: row.drivername },
                      { label: "Pickup Time", value: row.ridestarttime },
                      { label: "Drop Time", value: row.rideendtime },
                      { label: "Distance", value: row?.distance },
                      { label: "Trip Duration", value: row?.tripduration },
                      { label: "Base Fare", value: row?.baseprice },

			{ label: "Booking Fee", value: row?.bookingfee },

                      { label: "Distance Fare", value: row?.distancefare },
                      { label: "Minute Fare", value: row?.minutefare },
                      { label: "Onboarding Waiting Fare", value: row.onboardingwaitingfare },
                      { label: "Stop Waiting Fare", value: row.stopwaitingfare },
                       { label: "Add To Fare", value: row.addtofare },
                      { label:  "Increased Fare", value: row.fareincrease },
                      { label:  "Decreased Fare", value: row.faredecrease },
                      { label: "Extra Fare", value: row.extrafare },
                      { label: "Tax", value: row.tax },
                      { label: "Total Fare", value: row.amount },

			{ label: "Ride Cancelled By", value: row.cancelledBy },
                      { label: "Cancellation Reason", value: row.cancelReason }, 

                    ].map((item, idx) => (
                      <Grid container key={idx} sx={{ mb: 1 }}>
                        <Grid item xs={6}>
                          <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                            {item.label}:
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="body2">
                            {item?.value ? item.value : "-"}
                          </Typography>
                        </Grid>
                      </Grid>
                    ))}
                  </CardContent>
                </Card>
              </Grid>

              {/* Right Section */}
              <Grid item xs={12} md={6}>
                <Card sx={{ p: 2, borderRadius: "12px", backgroundColor: "#fff" }}>
                  <CardContent>
                    <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
                      Ride Locations
                    </Typography>
                    {[
                      { label: "Pickup Location", value: row.pickupaddress },
                      { label: "Stop1 Location", value: row.stop1_address },
                      { label: "Stop2 Location", value: row.stop2_address },
                      { label: "Stop3 Location", value: row.stop3_address },
                      { label: "Drop Location", value: row.dropaddress },
                      { label: "Onboard Waiting Time", value: row.onboardingwaitingtime },
                      { label: "Stops Waiting Time", value: row.tripwaitingtime },
                      { label: "User Notes for Driver", value: row.user_notes },
                    ].map((item, idx) => (
                      <Grid container key={idx} sx={{ mb: 1 }}>
                        <Grid item xs={6}>
                          <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                            {item.label}:
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="body2">
                            {item.value ? item.value : "-"}
                          </Typography>
                        </Grid>
                      </Grid>
                    ))}

{/* chat model */}

<Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
Chat History : 
</Typography>
  {Array.isArray(chatdetails) && chatdetails.length > 0 ? (
    <CardContent>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ChatApp chatdetails={chatdetails} />
        </Grid>
      </Grid>
    </CardContent>
  ) : (
    <Typography variant="body1" sx={{ p: 2, textAlign: "center" }}>
      No Chat history available.
    </Typography>
  )}

                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </CardContent>
        ))
      ) : (
        <Typography variant="body1" sx={{ p: 2, textAlign: "center" }}>
          No details available.
        </Typography>
      )} 

    </Card>

{/*Map */}

<Grid item xs={12} className={classes.tripmap} >
<APIProvider 
apiKey={API_ENDPOINTS.GMAP_API} // Use your actual API key
libraries={libraries}
>

<Map
      style={{
        width: '70vw',
        height: '70vh',
        margin: '30px 0',
      }}
      defaultCenter={ dataRows.length
      ? { lat: dataRows[0].pickuplat, lng: dataRows[0].pickuplong }
      : { lat: 0, lng: 0 }}
      defaultZoom={9}
      gestureHandling={'greedy'}
      mapId={"40acc4eff4be812f"}
    >
  <Directions dataRows={dataRows} />
    </Map>
  </APIProvider>
</Grid>

  </DialogContent>
<Divider />
<DialogActions>
<section className={classes.dialogActions}>
  <section className={classes.closeBtn}>
    <Button onClick={handleClose}>Close</Button>
  </section>
</section>
</DialogActions>
</Dialog>
    </>
  );
};



export default PassengerUpdate;
